import styled from "styled-components";
import { useFetchEntities } from "@/reactQueryHooks";
import { v4 as uuidv4 } from "uuid";
import ScheduleInfoTooltip from "./ScheduleInfoTooltip";

//----------------------------------

const Container = styled.div<{ isHovered: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 8px 12px;
  background-color: ${({ isHovered }) =>
    isHovered ? "rgb(215 232 255)" : "whitesmoke"};
  transition: background-color 0.2s ease;
  border-right: 1px solid #e0e0e0;
  gap: 6px;
  //z-index: 110;
`;

const UserName = styled.div`
  font-weight: bold;
  font-size: 12px;
  display: block;
  color: #333;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 2px;
`;

const RolesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 100%;
`;

// Role badge with dynamic color based on roleIndex
const RoleBadge = styled.div<{ roleColor: string }>`
  font-size: 10px;
  font-weight: 600;
  padding: 3px 7px;
  border-radius: 12px;
  background-color: #f1f3f5;
  color: #3a4c5a;
  white-space: nowrap;
  display: flex;
  align-items: center;

  &:before {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ roleColor }) => roleColor};
    margin-right: 5px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  }
`;

// Array of solid colors for different roles
const roleColors = [
  "#3050cc", // Dark Blue
  "#cc304e", // Dark Red
  "#30cc50", // Dark Green
  "#494949", // Dark Gray
  "#5930cc", // Dark Purple
  "#cc9930", // Dark Gold
  "#30b2cc", // Dark Teal
  "#9930cc", // Dark Violet
  "#307acc", // Navy Blue
  "#cc30b2", // Dark Magenta
];

// Error color for "No roles" badge
const errorColor = "#cc3030"; // Dark Red

//----------------------------------

const UserBox = ({ isHovered, user }: { isHovered: boolean; user: any }) => {
  const { data: entities } = useFetchEntities() as any;
  const allRoles = entities.data.roles;

  const userData = entities.data.staff.find(
    (staff: any) => staff._id === user.value
  );

  const userRolesIds = userData?.roles.map((role: any) => role._id);
  const userRoles = allRoles.filter((role: any) =>
    userRolesIds.includes(role._id)
  );

  // Function to determine the color for a role based on its index in allRoles
  const getRoleColor = (role: any) => {
    const roleIndex = allRoles.findIndex((r: any) => r._id === role._id);
    if (roleIndex === -1) return roleColors[0]; // fallback to first color
    return roleColors[roleIndex % roleColors.length];
  };

  return (
    <Container className={`cell sticky-col`} isHovered={isHovered}>
      <ScheduleInfoTooltip userData={userData} />
      <UserName>{userData.name}</UserName>

      <RolesContainer>
        {userRoles.map((role: any) => (
          <RoleBadge key={uuidv4()} roleColor={getRoleColor(role)}>
            {role.title}
          </RoleBadge>
        ))}

        {userRoles.length === 0 && (
          <RoleBadge roleColor={errorColor}>No roles</RoleBadge>
        )}
      </RolesContainer>
    </Container>
  );
};

export default UserBox;
